import React from 'react';
import {func} from 'prop-types';

import ActionsPanelItem from '../../components/ActionsPanelItem';

import classes from './ActionInsert.module.css';

const AreaItemActionInsert = ({
    onToggleCreateAreaModal
}) => {

    return (
        <div className={classes.agentActions}>
            <ActionsPanelItem
                title="Create a new Area"
                iconUrl="/assets/images/areaTreeIcon.svg"
                onClick={() => onToggleCreateAreaModal(true)}
            />
        </div>
    );
};

AreaItemActionInsert.defaultProps = {
    onToggleCreateAreaModal: () => {}
};

AreaItemActionInsert.propTypes = {
    onToggleCreateAreaModal: func
};

export default AreaItemActionInsert;
